import { Tileset } from './tileset';
import { Map } from './map';
import { dataType } from './dataType';
import { moveType } from './moveType';
import { CollectionData } from './dataLayers/collectionData';
import { Point, Rectangle } from 'pixi.js';


const defaults = {
    splitLayer: 'CHARACTER',
    dataLayerIds: {}
};

// Tiled format parser. Creates a map.
export class TiledParser {
    constructor(opts) {
        this.options = Object.assign({}, defaults, opts);
        this.init(this.options);
    }

    init(options) {
        this.tileIdToMoveType = options.tileIdToMoveType;
        this.dataLayerIds = options.dataLayerIds;
        this.collectionData = new CollectionData();

        this.splitLayer = options.splitLayer;
        this.foundSplitLayer = false;

        if (this.options.spawnPos) this.options.spawnPos = new Point(this.options.spawnPos.x, this.options.spawnPos.y);
    }

    generateMap(mapData) {
        mapData = Object.assign({}, this.options, mapData);
        this.init(mapData);

        let mapJSON = mapData.data;
        let map = new Map(mapData, mapJSON.width, mapJSON.height, mapJSON.tilewidth, mapJSON.tileheight);

        this.processTilesets(map, mapJSON);
        this.processLayers(map, mapJSON);

        return map;
    }

    processTilesets(map, mapJSON) {
        for (let i = 0; i < mapJSON.tilesets.length; i++) {
            const tsData = mapJSON.tilesets[i];
            let tilesetType = tsData.image ? Tileset.type.imageTiles : Tileset.type.tile;
            let opts = {
                firstId: tsData.firstgid,
                lastId: tsData.firstgid + tsData.tilecount - 1,
                tileWidth: tsData.tilewidth,
                tileHeight: tsData.tileheight,
                margin: tsData.margin,
                spacing: tsData.spacing,
                columns: tsData.columns
            };
            let tileset = new Tileset(tsData.name, tilesetType, opts);
            map.addTileset(tileset);
        }
    }

    processLayers(map, mapJSON) {
        for (let i = 0; i < mapJSON.layers.length; i++) {
            const layer = mapJSON.layers[i];

            // Skip the split layer as it contains no data.
            if (layer.name === this.splitLayer) {
                this.foundSplitLayer = true;
                continue;
            }

            // Check if the layer is a data layer.
            if (this.checkIfDataLayer(layer)) {
                let processedLayer = this.processDataLayer(layer);
                if (processedLayer) map.addDataLayer(processedLayer);
            } else {
                let processedLayer = this.processVisualLayer(layer);
                if (processedLayer) {
                    if (!this.foundSplitLayer) map.addVisualBottomLayer(processedLayer);
                    else map.addVisualTopLayer(processedLayer);
                }
            }
        }
    }

    processDataLayer(layer) {
        switch (layer.dataType) {
            case dataType.movement:
                return {
                    id: layer.id,
                    name: layer.name,
                    dataType: layer.dataType,
                    data: this.convertMoveData(layer.data.slice())
                };
            case dataType.collect:
                return {
                    id: layer.id,
                    name: layer.name,
                    dataType: layer.dataType,
                    data: this.convertCollectData(layer.data.slice())
                };
            case dataType.teleports:
                return {
                    id: layer.id,
                    name: layer.name,
                    dataType: layer.dataType,
                    data: this.convertTeleportsData(layer.objects.slice())
                };
            default:
                break;
        }
    }

    convertMoveData(flatGrid) {
        for (let i = 0; i < flatGrid.length; i++) {
            flatGrid[i] = moveType[this.tileIdToMoveType[flatGrid[i]]] ? moveType[this.tileIdToMoveType[flatGrid[i]]] : 0;
        }

        return flatGrid;
    }

    convertCollectData(flatGrid) {
        for (let i = 0; i < flatGrid.length; i++) {
            flatGrid[i] = flatGrid[i] !== 0 ? 1 : 0;
        }

        return flatGrid;
    }

    convertTeleportsData(teleports) {
        let teleporters = [];
        let finalTeleport = {};

        for (let i = 0; i < teleports.length; i++) {
            finalTeleport.bounds = new Rectangle(teleports[i].x, teleports[i].y, teleports[i].width, teleports[i].height);

            for (let j = 0; j < teleports[i].properties.length; j++) {
                if (teleports[i].properties[j].name === "id") {
                    finalTeleport.id = teleports[i].properties[j].value;
                } else if (teleports[i].properties[j].name === "to") {
                    finalTeleport.to = teleports[i].properties[j].value;
                }
            }

            teleporters.push(finalTeleport);
        }

        return teleporters;
    }

    processVisualLayer(layer) {
        switch (layer.type) {
            case 'tilelayer':
                return {
                    id: layer.id,
                    name: layer.name,
                    data: layer.data.slice()
                };
            // case 'collectlayer':
            //     return {
            //         id: layer.id,
            //         name: layer.name,
            //         data: layer.data.slice()
            //     };
            case 'objectgroup':
                break;
            default:
                break;
        }
    }

    checkIfDataLayer(layer) {
        let isData = false;

        isData = layer?.properties?.some((property) => {
            return property ?.name == 'isData';
        });

        Object.keys(this.dataLayerIds).forEach((key) => {
            if (this.dataLayerIds[key].includes(layer.name)) {
                layer.dataType = key.toUpperCase();
                isData = true;
            }
        });
        if (layer.properties){
            for (let i = 0; i < layer.properties.length; i++){
                if (layer.properties[i].name === "dataType") {
                    layer.dataType = layer.properties[i].value.toUpperCase();
                    isData = true;
                }
            }
        }
        /*
        isData = this.dataLayerIds.some((dataType) => {
            return dataType.includes(layer.name);
        });
        */

        return isData;
    }
}
